// Session bootstrap for the game client.
//
// The etoo_session cookie is HttpOnly; this helper asks the auth service for
// the resolved identity and mints a guest session when none exists.

export type SessionKind = 'user' | 'guest';

export interface SessionInfo {
  kind: SessionKind;
  name: string | null;
  needsUsername?: boolean;
}

async function getJson<T>(path: string, init?: RequestInit): Promise<T | null> {
  try {
    const response = await fetch(`/api${path}`, { credentials: 'same-origin', ...init });
    if (!response.ok) return null;
    return (await response.json()) as T;
  } catch {
    return null;
  }
}

export async function ensureSession(): Promise<SessionInfo | null> {
  const existing = await getJson<SessionInfo>('/session');
  if (existing && existing.name) return existing;
  if (existing && existing.needsUsername) return existing;
  return getJson<SessionInfo>('/session/guest', { method: 'POST' });
}
